module.exports = __webpack_public_path__ + "img/associationMapWhite.ca1477a0.svg";